<div
    class="st-text-area-overlay-display"
    [class.st-text-area-overlay-required]="required && !value"
    [class.st-text-area-overlay-valid]="required && !value"
    [style.min-height]="minHeight"
    innerHTML="{{displayValue | linky : {stripPrefix: false} | highlight : textToHighlight: false }}"
></div>

<ng-template
    cdkConnectedOverlay
    #overlay="cdkConnectedOverlay"
    [cdkConnectedOverlayPanelClass]="panelClass"
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayMinWidth]="_triggerRect?.width"
    [cdkConnectedOverlayMinHeight]="minHeight"
    [cdkConnectedOverlayPositions]="connectedPositions"
    [cdkConnectedOverlayOpen]="isPanelOpen"
    (overlayKeydown)="onOverlayKeydown($event)"
    (attach)="panelAttached()"
>
    <textarea
        matInput
        cdkTextareaAutosize
        class="st-text-area-overlay-input"
        [ngModel]="value"
        [placeholder]="label || placeholder"
        [required]="required"
        [cdkAutosizeMinRows]="minRows"
        [cdkAutosizeMaxRows]="15"
        [dir]="dir"
        (keydown.enter)="onTextAreaEnter($event)"
        [disabled]="disabled"
        [maxLength]="maxLength"
        (change)="onValueChanged()"
        (blur)="onFocusOut($event)"
        (ngModelChange)="onNgModelChanged($event)"
    >
    </textarea>
</ng-template>
